"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Colour = _interopRequireDefault(require("../../../colour/Colour"));
var _ColourList = _interopRequireDefault(require("../../../colour/ColourList"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var MAX_OPTIONS_TO_SHOW = 6;
var ColourOptions = function ColourOptions(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? '' : _ref$brand,
    _ref$hasDiorPromosEna = _ref.hasDiorPromosEnabled,
    hasDiorPromosEnabled = _ref$hasDiorPromosEna === void 0 ? false : _ref$hasDiorPromosEna,
    _ref$handleOptionClic = _ref.handleOptionClick,
    handleOptionClick = _ref$handleOptionClic === void 0 ? function () {} : _ref$handleOptionClic,
    _ref$offerTypeSummary = _ref.offerTypeSummary,
    offerTypeSummary = _ref$offerTypeSummary === void 0 ? {} : _ref$offerTypeSummary,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$selectedOption = _ref.selectedOption,
    selectedOption = _ref$selectedOption === void 0 ? null : _ref$selectedOption;
  if (!options.length) {
    return '';
  }
  var selectedColour = !selectedOption ? options[0].colour : selectedOption;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ColourList.default, {
    brand: brand,
    hasDiorPromosEnabled: hasDiorPromosEnabled,
    hideLabel: true,
    showMore: MAX_OPTIONS_TO_SHOW,
    onClick: handleOptionClick,
    children: options.map(function (item) {
      var colourOfferTypeSummary = offerTypeSummary[item.colour];
      var colourId = item.colour && item.colour.replace ? item.colour.replace(/\s+/g, '-').toLowerCase() : '';
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Colour.default, {
        hasReducedPrice: Boolean(colourOfferTypeSummary),
        id: "colour-".concat(colourId),
        reducedPriceText: colourOfferTypeSummary,
        selected: selectedColour === item.colour,
        swatch: item.swatchImage,
        unavailable: !item.inStock,
        value: item.colour
      }, item.colour);
    })
  });
};
ColourOptions.propTypes = {
  handleOptionClick: _propTypes.default.func,
  offerTypeSummary: _propTypes.default.objectOf(_propTypes.default.string),
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    colour: _propTypes.default.string,
    inStock: _propTypes.default.bool,
    pdpUrl: _propTypes.default.string,
    swatchImage: _propTypes.default.string
  })),
  selectedOption: _propTypes.default.string
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(ColourOptions);